import { Grid } from "@mui/material"
import {
    GridToolbarContainer,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
    GridToolbarExport
} from "@mui/x-data-grid"
import { ButtonStyles } from "../styles/AdminStyles"

function AuditToolBar() {
    return (
        <Grid>
            {/*ToolBar*/}
            <GridToolbarContainer sx={ButtonStyles}>
                <GridToolbarFilterButton sx={ButtonStyles} />
                <GridToolbarDensitySelector sx={ButtonStyles} />
                <GridToolbarExport sx={ButtonStyles} />
            </GridToolbarContainer>
        </Grid>
    )
}

export default AuditToolBar
